import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { SuiModule } from 'ng2-semantic-ui';
import { ModalDialogModule } from 'ngx-modal-dialog';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { TextMaskModule } from 'angular2-text-mask';
import { NgxStripeModule } from 'ngx-stripe';

import { AlertComponent, FormErrorComponent, ResizeDirective } from '../_directives/index';
import { OrderBy, PhoneWithExtPipe, SanitizeHtmlPipe, GroupByPipe } from '../_pipes/index';
import { AlertService, AuthenticationService, LocalDataService,
	AppDataService, OrdersService, PaymentsService, CustomModalService, UtilsService, CanDeactivateGuard } from '../_services/index';

import { ConfirmModalComponent, AlertModalComponent } from '../_shared/index';
import { ModalComponent } from '../modal/modal.component';

@NgModule({
  imports: [
    CommonModule,
    SuiModule,
    // NgxStripeModule.forRoot('pk_live_pCsvExXhJLLUhmn5Yu67gIW5'), // This is for activated Stripe account ('eDelivery')
    // NgxStripeModule.forRoot('pk_test_WsJgntH9qixV9AawTeqJULyb'), // This is for test Stripe account ('eDelivery')
    NgxStripeModule.forRoot('pk_test_VJaulQVjdHxerJzvzsYhNkwX'), // This is for test Stripe account ('eDelivery Testing')
    FormsModule, 
    ReactiveFormsModule,
    ModalDialogModule.forRoot(),
		GooglePlaceModule,
		AngularFontAwesomeModule,
		TextMaskModule,
    RouterModule
  ],
  declarations: [
    AlertComponent,
    FormErrorComponent,
    ResizeDirective,
    OrderBy,
    PhoneWithExtPipe,
    SanitizeHtmlPipe,
    GroupByPipe,
    ConfirmModalComponent,
		AlertModalComponent,
		ModalComponent
  ],
  providers: [
    AlertService,
    AuthenticationService,
    LocalDataService,
    AppDataService,
    OrdersService,
    PaymentsService,
    CustomModalService,
    UtilsService,
    CanDeactivateGuard
  ],
  exports: [
    AlertComponent,
    FormErrorComponent,
    ResizeDirective,
    OrderBy,
    PhoneWithExtPipe,
    SanitizeHtmlPipe,
    GroupByPipe,
    ConfirmModalComponent,
		AlertModalComponent,
		ModalComponent,
    CommonModule,
    SuiModule,
    NgxStripeModule,
    FormsModule,
    ReactiveFormsModule,
		GooglePlaceModule,
		AngularFontAwesomeModule,
		TextMaskModule,
    RouterModule
  ]
})
export class SharedModule { }
